export default __webpack_public_path__ + "static/media/cart.7b8fa892.svg";